<template>
    <popper
        :trigger="trigger"
        :options="options">

        <div class="popper">
            <slot name="content"></slot>
        </div>

        <button slot="reference">
            <slot></slot>
        </button>

    </popper>
</template>

<script>
    import Popper from 'vue-popperjs';
    import 'vue-popperjs/dist/vue-popper.css';

    export default {
        name: "tooltip",
        props: {
            trigger: {
                type: String,
                default: 'hover',
                validator: (value) => {
                    return ['hover', 'clickToOpen', 'clickToToggle', 'click', 'focus'].indexOf(value) !== -1
                },
            },
            options: {
                type: Object,
                default: () => {
                    return { placement: 'top' }
                }
            }
        },
        components: {
            'popper': Popper
        }
    }
</script>

<style lang="scss" scoped>
    .popper{
        -webkit-box-shadow: 0 10px 50px 0 rgba(0, 0, 0, .2);
        box-shadow: 0 10px 50px 0 rgba(0, 0, 0, .2);
        transition: all 0.3s ease-out 0s;
    }
</style>
